import React from "react"
import { Link } from "gatsby"

import { addYears, addMonths, addDays } from "date-fns"

export const DrupalLink = ({ to = "", children, ...props }) => {
  to = to.includes("force.com") ? process.env.GATSBY_SALESFORCE_URL : to
  if (to.endsWith("/join")) {
    return (
      <a {...props} href={to.replace("internal:", "")}>
        {children}
      </a>
    )
  }
  to = to.replaceAll(`/${process.env.GATSBY_SITE}/`, "/")
  const component = to.includes("internal:") ? (
    <Link {...props} to={to.replace("internal:", "")}>
      {children}
    </Link>
  ) : (
    <a
      {...props}
      rel="external nofollow noreferrer noopener"
      target="_blank"
      href={to}
    >
      {children}
    </a>
  )

  return component
}

export const convertWebformDate = (str) => {
  //let converted = str === 'now' ? new Date() : str;
  // converted =
  const start = new Date()

  if (str === "now") {
    return start
  }

  if (str.includes("years")) {
    const parts = str.split(" ")
    const addition = parseInt(parts[0])
    return addYears(start, addition)
  }

  if (str.includes("months")) {
    const parts = str.split(" ")
    const addition = parseInt(parts[0])
    return addMonths(start, addition)
  }

  if (str.includes("days")) {
    const parts = str.split(" ")
    const addition = parseInt(parts[0])
    return addDays(start, addition)
  }
}
